(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["multiple-media-with-text"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var slides = document.querySelectorAll('#concept-slider .herb-slide');
  var currentSlide = 0;

  setInterval(function () {
    slides[currentSlide].classList.remove('active');
    currentSlide = (currentSlide + 1) % slides.length;
    slides[currentSlide].classList.add('active');
  }, 4000);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-accordion"] && !Shopify.designMode) return;
  try {
    

document.querySelectorAll('.accordion').forEach(accordion => {

  accordion.querySelectorAll('.accordion-title').forEach(button => {

    button.addEventListener('click', () => {

      const item = button.closest('.accordion-item');

      const isOpen = item.classList.contains('open');


      accordion.querySelectorAll('.accordion-item').forEach(otherItem => {

        otherItem.classList.remove('open');

        const otherButton =
          otherItem.querySelector('.accordion-title');

        if (otherButton) {

          otherButton.setAttribute(
            'aria-expanded',
            'false'
          );

        }

      });


      if (!isOpen) {

        item.classList.add('open');

        button.setAttribute(
          'aria-expanded',
          'true'
        );

      }

    });

  });

});


  } catch(e) { console.error(e); }
})();
})();
